import { generatePath } from 'react-router';

import { Roles } from '~/data/user';

export const employeeModulesAccessRoles = (() => {
  const allModulesAccessRoles = [
    Roles.ALT_MANAGER,
    Roles.MANAGER,

    Roles.HR_STAFF,
    Roles.HR_ADMIN,
    Roles.HR_ADMIN_LIMITED,
    Roles.HR_SALARY,
    Roles.HR_DEV,
  ];

  const peopleFull = [
    ...allModulesAccessRoles,
    Roles.DEPUTY_MANAGER,
    Roles.HR_PEOP,
    Roles.HR_PEOP_DEV,
  ];

  return {
    allModules: allModulesAccessRoles,
    people: {
      full: peopleFull,
      all: [...peopleFull, Roles.IT_ADMIN],
    },
    rewarding: allModulesAccessRoles,
    performance: [...allModulesAccessRoles, Roles.DEPUTY_MANAGER],
    development: [
      ...allModulesAccessRoles,
      Roles.DEPUTY_MANAGER,
      Roles.HR_PEOP_DEV,
    ],
  };
})();

export enum EmployeeViewModules {
  People = 'people',
  Rewarding = 'rewarding',
  Performance = 'performance',
  Development = 'development',
}

export const getEmployeeModuleTabPath = (
  employeeId: number,
  module?: EmployeeViewModules,
  tab?: string,
) => {
  if (!!module && !!tab) {
    return generatePath('/portal/employee/:employeeId/:module/:tab', {
      employeeId,
      module,
      tab,
    });
  } else if (!!module) {
    return generatePath('/portal/employee/:employeeId/:module', {
      employeeId,
      module,
    });
  }

  return generatePath('/portal/employee/:employeeId/', {
    employeeId,
  });
};
